export const BACKEND_URL = 'https://api.werstack.com';
export const PUBLIC_URL = 'https://werstack.com';
export const MEDIA_URL = 'https://media.werstack.com';
export const DATA_API_URL = 'https://api.werstack.com/data';
export const WORKFLOW_API_URL = 'https://api.werstack.com/workflow';
export const GRAFANA_URL = 'https://metrik.werstack.com';

//export const BACKEND_URL = 'http://localhost:3001';
//export const PUBLIC_URL = 'http://localhost:3001';
//export const MEDIA_URL = 'http://localhost:9000/media';
//export const DATA_API_URL = 'http://localhost:3002';
//export const WORKFLOW_API_URL = 'http://localhost:3003';
//export const GRAFANA_URL = 'http://localhost:3100';
